import styled from 'styled-components';

import { Box } from '../../../grid';

export const NavigationButton = styled(Box).attrs(() => ({
  as: 'button',
  display: { _: 'none', md: 'flex' },
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  border: '1px solid',
  width: '36px',
  height: '36px',
  'aria-hidden': true,
}))`
  background-color: transparent;
  transition: background-color 300ms ease-in-out;
`;
